import moment from "moment";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { AppIcons } from "../constants/app-icons";
export default class EmailService extends ApiService {
  template = "defaultTemplate";
  namespace = "email";
  listingRelations = "peopleCount";
  relations = "?expand=people,people.person,peopleSimple";
  icon = "Mail";
  favicon = "Mail";
  DOMAIN = 208;
  action = "action";

  search = true;
  singular = this.terminology.email.singular;
  plural = this.terminology.email.plural;
  vowel = this.terminology.email.vowel;
  name = `${this.vowel} ${this.singular}`;
  Width = 1200;
  gemItems = [
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "create",
      label: this.t("addAnEntity", {
        entity: this.terminology.emailTemplate.singular,
      }),
      icon: AppIcons.PLUS,
      services: -21,
    },
    {
      key: "listing",
      label: this.t("allEntity", {
        entity: this.terminology.emailTemplate.plural,
      }),
      icon: AppIcons.BULLETS,
      services: -21,
    },
    {
      key: "create",
      label: this.t("addAnEntity", {
        entity: this.terminology.emailSignature.singular,
      }),
      icon: AppIcons.PLUS,
      services: 209,
    },
    {
      key: "listing",
      label: this.t("allEntity", {
        entity: this.terminology.emailSignature.plural,
      }),
      icon: AppIcons.BULLETS,
      services: 209,
    },
    {
      key: "create",
      label: this.t("addAnEntity", {
        entity: this.terminology.sentEmail.singular,
      }),
      icon: AppIcons.PLUS,
      services: 210,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.terminology.sentEmail.plural }),
      icon: AppIcons.BULLETS,
      services: 210,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit " + this.name,
      icon: AppIcons.EDIT,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: this.t("numberOfPeople"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "peopleCount",
    },
    {
      header: this.t("schedule"),
      icon: AppIcons.ALARM,
      field: "schedule_time",
      template: (data) => {
        return data.schedule_time > 0
          ? moment.unix(data.schedule_time).format("MM/DD/YYYY HH:ii")
          : "Send Now";
      },
    },
    {
      header: this.t("status"),
      icon: AppIcons.MAILS,
      field: "is_sent",
      template: (data) => {
        return !data.is_sent
          ? "Pending (Queued)"
          : data.is_sent == 1
            ? "Sent"
            : "Declined";
      },
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return moment.unix(data.created_at).format("MM/DD/YYYY");
      },
    },
  ];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Edit an Employee",
        icon: AppIcons.EDIT,
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? AppIcons.DISABLE : AppIcons.ENABLED,
      },
    ];
    return listMenuItems;
  }

  navItems = [
    {
      key: "active",
      label: this.t("viewActiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.ENABLED,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
  ];
  filterItems = [
    {
      name: "Employees",
      key: "type",
      serviceId: 17,
      params: { realm: 2 },
      value: "2",
      realm: "2",
      selected: true,
      item: { key: "id", label: "display_name" },
    },
    {
      name: "Vendors",
      serviceId: 18,
      key: "type",
      params: { realm: 1 },
      value: "3",
      realm: "1",
      selected: false,

      item: { key: "id", label: "display_name" },
    },
    {
      name: "Folders",
      icon: "FolderOpened",
      serviceId: "-2",
      params: { realm: 1 },
      item: { key: "id", label: "display_name" },
      value: "-2",
      realm: "0",
      selected: false,
      add: "create",
      edit: "listing",
    },
  ];
  constructor() {
    super("emails");
  }
}
